import React, { useState } from 'react';
import './UploadLoadImage.scss';
import { Row, Col } from 'react-bootstrap';
import TextContent from '../../../../_common/TextContent/TextContent';
import FullLoadImage from '../FullLoadImage';
import useRemoveReplaceImage from '../useRemoveReplaceImage';
import uploadImage from '../../../../../assets/upload-image.png';
import { CustomButton, Loading } from '../../../../_common';
import { LoadStatusEnum } from '../../../../../types/LoadStatusEnum';
import { useMutation } from '@apollo/client/react';
import { CombinedGraphQLErrors } from '@apollo/client';
import { UPLOAD_IMAGE_TO_LOAD } from '../../../../../graphql/client/mutations';
import { GET_LOAD_PROGRESS } from '../../../../../graphql/client/queries';
import { UploadImageToLoadInputDetails, UploadImageToLoadInput } from '../../../../../types/schemaTypes';

interface UploadLoadImageProps {
    ticketNumber?: string | null;
    ticketImage?: string | null;
    ticketUploadedBy?: string | null;
    imageText?: string;
    ticketUploadedAt?: string | null;
    loadId?: number;
    ticketName?: string;
    canUploadImage?: boolean;
    loadStatus?: string;
}

const UploadLoadImage = ({
    ticketNumber,
    ticketImage,
    ticketUploadedBy,
    imageText,
    ticketUploadedAt,
    ticketName,
    loadId,
    canUploadImage,
    loadStatus,
}: UploadLoadImageProps): React.ReactElement => {
    const [showModal, setShowModal] = useState(false);

    const handleOnClick = (): void => {
        setShowModal(!showModal);
    };

    const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
    const [uploadImageMutation, { loading: mutationLoading }] = useMutation(UPLOAD_IMAGE_TO_LOAD, {
        onError: (e) => {
            if (CombinedGraphQLErrors.is(e)) {
                console.log('GraphQL Error', e.errors);
            } else {
                console.log('Error', e.message);
            }
        },
        refetchQueries: () => {
            return [
                {
                    query: GET_LOAD_PROGRESS,
                    variables: { loadId: loadId },
                },
            ];
        },
    });

    const handleAllChanges = async (event: any, ticketName: string): Promise<any> => {
        const reader = new FileReader();
        const file = event.target.files[0];

        let extension = '';
        let imageData = '';
        reader.onloadend = async () => {
            extension = file.name.split('.').pop();
            imageData = reader.result ? reader.result.toString().replace(/^data:(.*,)?/, '') : '';
        };
        reader.readAsDataURL(file);
        //Since FileReader taking a while to fill extension and imageData have used setTimeout
        setTimeout(() => {
            let imageName = '';
            if (ticketName === 'stn') {
                imageName = `Load-${loadId}-Stn2.${extension.toLowerCase()}`;
            }
            if (ticketName === 'bol') {
                imageName = `Load-${loadId}-Bol.${extension.toLowerCase()}`;
            }
            if (ticketName === 'bol2') {
                imageName = `Load-${loadId}-Other.${extension.toLowerCase()}`;
            }
            if (event) {
                event.preventDefault();
            }

            const uploadImageToLoadInputDetails: UploadImageToLoadInputDetails = {
                imageName: imageName,
                imageData: imageData,
                name: ticketName,
                isDriver: false,
            };

            const uploadImageToLoadInput: UploadImageToLoadInput = {
                loadId: loadId,
                uploadImageToLoad: uploadImageToLoadInputDetails,
            };
            uploadImageMutation({
                variables: { input: uploadImageToLoadInput },
            });
        }, 200);
    };
    const {
        handleAllChangesForReplaceImage,
        handleAllChangesForRemoveImage,
        replaceMutationLoading,
    } = useRemoveReplaceImage(ticketName || '', loadId || 0);
    return (
        <Col>
            <Row className="LoadDetail-Title">
                <TextContent hasTopMargin title={imageText || ''} value={ticketNumber || ''}></TextContent>
            </Row>
            <Row className='Ticket-image'>
                {ticketImage != null && ticketImage != '' ? (
                    <div>
                        {replaceMutationLoading ? (
                            <div className={`LoadDetail-Image ${!canUploadImage && 'LoadDetail-Image-Disabled'}`}>
                                <span>
                                    <label className="UploadImage-Label" htmlFor="exampleFormControlFile1">
                                        <div>
                                            <div className="LoadingImage-Icon"></div>
                                            <span className="LoadingImage-Span">
                                                <Loading />
                                            </span>
                                        </div>
                                    </label>
                                </span>{' '}
                            </div>
                        ) : (
                            <div>
                                <img className="image" src={ticketImage} onClick={handleOnClick} />
                                {showModal && (
                                    <FullLoadImage
                                        onClickShow={() => setShowModal(true)}
                                        show={showModal}
                                        onClickHide={handleOnClick}
                                        image={ticketImage}
                                    />
                                )}
                                {showConfirmDeleteModal && (
                                    <div className="ConfirmDelete-Modal">
                                        <div
                                            className="ConfirmDelete-CloseButton"
                                            onClick={(): void => setShowConfirmDeleteModal(false)}
                                        >
                                            <i className="material-icons">close</i>
                                        </div>
                                        <div className="ConfirmDeleteImageModal-Body">
                                            Are you sure you want to delete this image?
                                        </div>
                                        <div className="ConfirmDeleteImageModal-Button">
                                            <CustomButton
                                                title="Confirm"
                                                isBordered={false}
                                                onClick={() => {
                                                    handleAllChangesForRemoveImage(ticketName);
                                                    setShowConfirmDeleteModal(false);
                                                }}
                                            ></CustomButton>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                ) : (
                    <div className={`LoadDetail-Image ${!canUploadImage && 'LoadDetail-Image-Disabled'}`}>
                        {canUploadImage && loadStatus !== LoadStatusEnum.COMPLETED ? (
                            <span>
                                {ticketName && ticketName === 'stn' ? (
                                    <label className="UploadImage-Label" htmlFor="exampleFormControlFile1">
                                        {mutationLoading ? (
                                            <div>
                                                <div className="LoadingImage-Icon"></div>
                                                <span className="LoadingImage-Span">
                                                    <Loading />
                                                </span>
                                            </div>
                                        ) : (
                                            <div>
                                                <img className="UploadImage-Icon" src={uploadImage} alt="upload icon" />
                                                <span className="UploadImage-Span">Upload Image</span>
                                            </div>
                                        )}

                                        <input
                                            type="file"
                                            className="d-none"
                                            id="exampleFormControlFile1"
                                            onChange={event => {
                                                handleAllChanges(event, ticketName || '');
                                            }}
                                        ></input>
                                    </label>
                                ) : ticketName === 'bol' ? (
                                    <label className="UploadImage-Label" htmlFor="exampleFormControlFile2">
                                        {mutationLoading ? (
                                            <div>
                                                <div className="LoadingImage-Icon"></div>
                                                <span className="LoadingImage-Span">
                                                    <Loading />
                                                </span>
                                            </div>
                                        ) : (
                                            <div>
                                                <img className="UploadImage-Icon" src={uploadImage} alt="upload icon" />
                                                <span className="UploadImage-Span">Upload Image</span>
                                            </div>
                                        )}

                                        <input
                                            type="file"
                                            className="d-none"
                                            id="exampleFormControlFile2"
                                            onChange={event => {
                                                handleAllChanges(event, ticketName || '');
                                            }}
                                        ></input>
                                    </label>
                                ) : (
                                    <label className="UploadImage-Label" htmlFor="exampleFormControlFile3">
                                        {mutationLoading ? (
                                            <div>
                                                <div className="LoadingImage-Icon"></div>
                                                <span className="LoadingImage-Span">
                                                    <Loading />
                                                </span>
                                            </div>
                                        ) : (
                                            <div>
                                                <img className="UploadImage-Icon" src={uploadImage} alt="upload icon" />
                                                <span className="UploadImage-Span">Upload Image</span>
                                            </div>
                                        )}

                                        <input
                                            type="file"
                                            className="d-none"
                                            id="exampleFormControlFile3"
                                            onChange={event => {
                                                handleAllChanges(event, ticketName || '');
                                            }}
                                        ></input>
                                    </label>
                                )}
                            </span>
                        ) : (
                            <label
                                className="UploadImage-Label UploadImage-Label-Disabled"
                                htmlFor="exampleFormControlFile1"
                            >
                                <div>
                                    <img className="UploadImage-Icon" src={uploadImage} alt="upload icon" />
                                    <span className="UploadImage-Span">Upload Image</span>
                                </div>
                            </label>
                        )}
                    </div>
                )}
            </Row>
            <Row>
                {ticketUploadedBy != null && ticketUploadedBy != '' ? (
                    <TextContent hasTopMargin title={'Uploaded by: '} value={ticketUploadedBy || ''}></TextContent>
                ) : (
                    <div></div>
                )}
            </Row>
            <Row>
                <TextContent hasTopMargin title={''} value={ticketUploadedAt || ''}></TextContent>
            </Row>
            <Row>
                {ticketImage != null && ticketImage != '' ? (
                    <div className="Image-Label">
                        {loadStatus !== LoadStatusEnum.COMPLETED ? (
                            <span>
                                {ticketName && ticketName === 'stn' ? (
                                    <label className="Replace-Label" htmlFor="replaceSandTicket">
                                        Replace
                                        <input
                                            type="file"
                                            className="d-none"
                                            id="replaceSandTicket"
                                            onChange={event => {
                                                handleAllChangesForReplaceImage(event, ticketName);
                                            }}
                                        ></input>
                                    </label>
                                ) : ticketName === 'bol' ? (
                                    <label className="Replace-Label Replace-Label-Disabled" htmlFor="replaceBolTicket">
                                        Replace
                                        <input
                                            type="file"
                                            className="d-none"
                                            id="replaceBolTicket"
                                            onChange={event => {
                                                handleAllChangesForReplaceImage(event, ticketName);
                                            }}
                                        ></input>
                                    </label>
                                ) : (
                                    <label className="Replace-Label" htmlFor="replaceAddTicket">
                                        Replace
                                        <input
                                            type="file"
                                            className="d-none"
                                            id="replaceAddTicket"
                                            onChange={event => {
                                                handleAllChangesForReplaceImage(event, ticketName);
                                            }}
                                        ></input>
                                    </label>
                                )}
                            </span>
                        ) : (
                            <label className="Replace-Label Replace-Label-Disabled">Replace</label>
                        )}
                        {loadStatus !== LoadStatusEnum.COMPLETED ? (
                            <label className="Delete-Label" onClick={(): void => setShowConfirmDeleteModal(true)}>
                                Delete
                            </label>
                        ) : (
                            <label className="Delete-Label Delete-Label-Disabled">Delete</label>
                        )}
                    </div>
                ) : (
                    <div></div>
                )}
            </Row>
        </Col>
    );
};

export default UploadLoadImage;
